import React, { useState } from 'react';
import { apiService } from '../services/apiService';
import { useAuth } from '../context/AuthContext';

export default function FeedbackFormInline() {
  const { user } = useAuth();
  const [message, setMessage] = useState('');
  const [rating, setRating] = useState(5);
  const [tags, setTags] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const reset = () => { setMessage(''); setRating(5); setTags(''); setError(null); setDone(false); };

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSubmitting(true); setError(null);
    try {
      await apiService.submitFeedback({
        message: message.trim(),
        rating: rating || undefined,
        tags: tags ? tags.split(',').map(t=>t.trim()).filter(Boolean) : undefined,
        // capture user info automatically
        meta: { 
          url: window.location.href, 
          ua: navigator.userAgent,
          userId: user?.id,
          userEmail: user?.email,
          userName: user?.displayName || user?.name || null
        }
      });
      setDone(true);
      setTimeout(() => { reset(); }, 1500);
    } catch (e2) {
      setError(e2.message || 'Failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">Message *</label>
        <textarea rows={5} value={message} onChange={e=>setMessage(e.target.value)} required placeholder="Describe issue, idea, or general feedback" className="w-full text-sm p-3 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400" />
      </div>
      <div className="flex gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">Rating</label>
          <select value={rating} onChange={e=>setRating(Number(e.target.value))} className="w-24 text-sm p-2 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700">
            {[5,4,3,2,1].map(r=> <option key={r} value={r}>{r}★</option>)}
          </select>
        </div>
        {user?.email && (
          <div className="flex items-end text-xs text-gray-500 dark:text-gray-400 pt-5">
            Logged in as {user.email}
          </div>
        )}
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">Tags</label>
        <input value={tags} onChange={e=>setTags(e.target.value)} placeholder="performance, ui, bug" className="w-full text-sm p-2 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
      </div>
      {error && <div className="text-xs text-red-500">{error}</div>}
      {done && <div className="text-xs text-green-600">Thank you! Stored securely.</div>}
      <div className="flex justify-end gap-2">
        <button type="button" onClick={reset} disabled={submitting} className="text-sm px-3 py-2 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">Reset</button>
        <button type="submit" disabled={submitting || !message.trim()} className="text-sm px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white font-medium">{submitting ? 'Sending…' : 'Send Feedback'}</button>
      </div>
    </form>
  );
}
